///////////////////////////////////////////////////
//dl-header.js
///////////////////////////////////////////////////
class DL_HeaderFunc {
  constructor(selector) {
    const header = this;
    header.elements = document.querySelector(selector);
    header.nav = document.querySelectorAll(".dl-header__nav");
    header.navParent = document.querySelectorAll(
      ".dl-header__nav__li.has-child"
    );

    if (header.navParent.length) {
      // DL_addClass(header.navParent[1], "is-active");
      for (var i = 0; i < header.navParent.length; i++) {
        const parent = header.navParent[i];
        parent.addEventListener(
          "click",
          function (e) {
            if (DL_hasClass(this, "is-active")) {
              // DL_removeClass(this, "is-active")
              // console.log(e.target.closest("a"))
              if (!e.target.closest(".dl-header__nav__child a")) {
                DL_removeClass(this, "is-active");
              }
            } else {
              DL_removeClass(header.navParent, "is-active");
              DL_addClass(this, "is-active");
            }
          },
          false
        );

        parent.child = parent.querySelectorAll(
          ".dl-header__nav__child__li.has-child:not(.is-side)"
        );
        parent.childSide = parent.querySelector(
          ".dl-header__nav__child__li.has-child.is-side"
        );

        if (parent.child.length) {
          DL_addClass(parent.child[0], "is-active");
          parent.childWrap = parent.querySelector(
            ".dl-header__nav__child__wrap"
          );
          for (var j = 0; j < parent.child.length; j++) {
            const child = parent.child[j];
            child.child = child.querySelector(".dl-header__nav__child__child");

            // child.addEventListener(
            //   "click",
            //   function(e) {
            //     if (DL_hasClass(this, "is-active")) {
            //       if (!e.target.closest("a")) {
            //         DL_removeClass(this, "is-active")
            //       }
            //     } else {
            //       DL_removeClass(parent.child, "is-active")
            //       DL_addClass(this, "is-active")
            //     }
            //   },
            //   false
            // );

            child.addEventListener("mouseover", function (event) {
              DL_removeClass(parent.child, "is-active");
              DL_addClass(this, "is-active");
            });

            // child.addEventListener('mouseout', function(event) {
            //   DL_removeClass(modal.image, "is-zoom");
            //   modal.image.style.transformOrigin = 'center center';
            // });
          }
        }
      }
    }

    window.addEventListener("resize", this.onResize.bind(this));
    header.init();
  }
  init() {
    const header = this;
    if (header.navParent.length) {
      for (var i = 0; i < header.navParent.length; i++) {
        const parent = header.navParent[i];

        if (parent.child.length) {
          let maxH = 0;

          parent.childWrap.style.height = maxH + "px";
          for (var j = 0; j < parent.child.length; j++) {
            const child = parent.child[j];
            if (child.child.offsetHeight > maxH) {
              maxH = child.child.offsetHeight;
            }
          }

          if (parent.childSide) {
            if (parent.childSide.offsetHeight > maxH) {
              maxH = parent.childSide.offsetHeight;
            }
          }
          parent.childWrap.style.height = maxH + "px";
        }
      }
    }
  }
  onResize() {
    this.init();
  }
}

new DL_HeaderFunc(".dl-header");
class DL_HbgFunc {
  constructor(selector) {
    const hbg = this;
    hbg.elements = document.querySelector(selector);
    hbg.openFlg = false;
    hbg.button = document.querySelector(".dl-js-hbgicon");
    hbg.button.addEventListener(
      "click",
      function (e) {
        if (hbg.openFlg) {
          hbg.close();
        } else {
          hbg.open();
        }
      },
      false
    );

    hbg.nav = document.querySelectorAll(".dl-header__hbgmenu__nav");
    hbg.navParent = document.querySelectorAll(
      ".dl-header__hbgmenu__nav__li.has-child"
    );
    if (hbg.navParent.length) {
      // DL_addClass(hbg.navParent[0], "is-active");
      // DL_slideDown(hbg.navParent[0].querySelector(".dl-header__hbgmenu__nav__child"), 0);
      for (var i = 0; i < hbg.navParent.length; i++) {
        const parent = hbg.navParent[i];
        parent.addEventListener(
          "click",
          function (e) {
            if (!DL_hasClass(this, "is-large")) {
              if (!e.target.closest(".dl-header__hbgmenu__nav__child a")) {
                if (DL_hasClass(this, "is-active")) {
                  DL_removeClass(this, "is-active");
                  DL_slideUp(
                    parent.querySelector(".dl-header__hbgmenu__nav__child")
                  );
                } else {
                  DL_addClass(this, "is-active");
                  DL_slideDown(
                    parent.querySelector(".dl-header__hbgmenu__nav__child")
                  );
                }
              }
            }
          },
          false
        );

        parent.child = parent.querySelectorAll(
          ".dl-header__hbgmenu__nav__child__li.has-child:not(.is-side)"
        );
        parent.childSide = parent.querySelector(
          ".dl-header__hbgmenu__nav__child__li.has-child.is-side"
        );
        parent.childIdx = 0;
        if (parent.child.length) {
          DL_addClass(parent.child[0], "is-active");
          parent.childWrap = parent.querySelector(
            ".dl-header__hbgmenu__nav__child__wrap"
          );
          for (var j = 0; j < parent.child.length; j++) {
            parent.child[j].setAttribute("data-index", j);
            const child = parent.child[j];
            child.child = child.querySelector(
              ".dl-header__hbgmenu__nav__child__child"
            );
            child.addEventListener(
              "click",
              function (e) {
                DL_removeClass(parent.child, "is-active");
                DL_addClass(this, "is-active");
              },
              false
            );
          }
        }
      }
    }

    // hbg.open();

    window.addEventListener("resize", hbg.updateMenuPosition)
  }
  updateMenuPosition() {
    const announcementBarElm = document.querySelector("#section-announcement");
    const announcementBarPos = announcementBarElm?.getBoundingClientRect();
    const announcementBarHeight = (announcementBarElm?.clientHeight ?? 0) + (announcementBarPos?.top ?? 0);
    
    const headerElm = document.querySelector(".dl-header");
    const headerHeight = headerElm?.clientHeight ?? 0;

    const headerMenu = document.querySelector("body .dl-header__hbgmenu");
    const sideMenus = document.querySelectorAll("body .dl-header__hbgmenu__nav__child__li.has-child:not(.is-side) .dl-header__hbgmenu__nav__child__child");

    if (window.innerWidth <= 1000) {
      headerMenu.style.paddingTop = (announcementBarHeight + headerHeight - 1) + "px";
      sideMenus?.forEach((sideMenu) => {
        sideMenu.style.paddingTop = (announcementBarHeight + headerHeight + 36 - 1) + "px";
      })
    } else {
      headerMenu.style.paddingTop = "0px";
      sideMenus?.forEach((sideMenu) => {
        sideMenu.style.paddingTop = "0px";
      })
    }
  }
  open() {
    const hbg = this;
    hbg.openFlg = true;
    DL_addClass(hbg.button, "is-active");
    DL_addClass(hbg.elements, "is-active");

    // document.body.style.overflow = "hidden";
    // DL_fadeIn(hbg.elements, 200, function() {
    //   document.body.style.overflow = "hidden";
    // });

    hbg.updateMenuPosition();
  }
  close() {
    const hbg = this;
    hbg.openFlg = false;
    DL_removeClass(hbg.button, "is-active");
    DL_removeClass(hbg.elements, "is-active");
    // document.body.style.overflow = "inherit";
    // DL_fadeOut(hbg.elements, 200, function() {
    //   // document.body.style.overflow = "hidden";
    // });
  }
}
new DL_HbgFunc(".dl-header__hbgmenu");
